/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Session } from '../models/Session';
import type { User } from '../models/User';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DefaultService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Sign in with a social provider
     * @returns any Success - Returns either session details or redirect URL
     * @throws ApiError
     */
    public socialSignIn({
        requestBody,
    }: {
        requestBody: {
            /**
             * Callback URL to redirect to after the user has signed in
             */
            callbackURL?: string | null;
            newUserCallbackURL?: string | null;
            /**
             * Callback URL to redirect to if an error happens
             */
            errorCallbackURL?: string | null;
            provider: string;
            /**
             * Disable automatic redirection to the provider. Useful for handling the redirection yourself
             */
            disableRedirect?: boolean | null;
            idToken?: {
                /**
                 * ID token from the provider
                 */
                token: string;
                /**
                 * Nonce used to generate the token
                 */
                nonce?: string | null;
                /**
                 * Access token from the provider
                 */
                accessToken?: string | null;
                /**
                 * Refresh token from the provider
                 */
                refreshToken?: string | null;
                /**
                 * Expiry date of the token
                 */
                expiresAt?: number | null;
            } | null;
            /**
             * Array of scopes to request from the provider. This will override the default scopes passed.
             */
            scopes?: any[] | null;
            /**
             * Explicitly request sign-up. Useful when disableImplicitSignUp is true for this provider
             */
            requestSignUp?: boolean | null;
            /**
             * The login hint to use for the authorization code request
             */
            loginHint?: string | null;
            additionalData?: string | null;
        },
    }): CancelablePromise<{
        token: string;
        user: User;
        url?: string;
        redirect: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/sign-in/social',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Get the current session
     * @returns any Success
     * @throws ApiError
     */
    public getSession(): CancelablePromise<{
        session: Session;
        user: User;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/get-session',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Sign out the current user
     * @returns any Success
     * @throws ApiError
     */
    public signOut({
        requestBody,
    }: {
        requestBody?: any,
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/sign-out',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Sign up a user using email and password
     * @returns any Successfully created user
     * @throws ApiError
     */
    public signUpWithEmailAndPassword({
        requestBody,
    }: {
        requestBody?: {
            /**
             * The name of the user
             */
            name: string;
            /**
             * The email of the user
             */
            email: string;
            /**
             * The password of the user
             */
            password: string;
            /**
             * The profile image URL of the user
             */
            image?: string;
            /**
             * The URL to use for email verification callback
             */
            callbackURL?: string;
            /**
             * If this is false, the session will not be remembered. Default is `true`.
             */
            rememberMe?: boolean;
        },
    }): CancelablePromise<{
        /**
         * Authentication token for the session
         */
        token?: string | null;
        user: {
            /**
             * The unique identifier of the user
             */
            id: string;
            /**
             * The email address of the user
             */
            email: string;
            /**
             * The name of the user
             */
            name: string;
            /**
             * The profile image URL of the user
             */
            image?: string | null;
            /**
             * Whether the email has been verified
             */
            emailVerified: boolean;
            /**
             * When the user was created
             */
            createdAt: string;
            /**
             * When the user was last updated
             */
            updatedAt: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/sign-up/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                422: `Unprocessable Entity. User already exists or failed to create user.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Sign in with email and password
     * @returns any Success - Returns either session details or redirect URL
     * @throws ApiError
     */
    public signInEmail({
        requestBody,
    }: {
        requestBody: {
            /**
             * Email of the user
             */
            email: string;
            /**
             * Password of the user
             */
            password: string;
            /**
             * Callback URL to use as a redirect for email verification
             */
            callbackURL?: string | null;
            rememberMe?: string | null;
        },
    }): CancelablePromise<{
        redirect: boolean;
        /**
         * Session token
         */
        token: string;
        url?: null | null;
        user: User;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/sign-in/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Reset the password for a user
     * @returns any Success
     * @throws ApiError
     */
    public resetPassword({
        requestBody,
    }: {
        requestBody: {
            /**
             * The new password to set
             */
            newPassword: string;
            /**
             * The token to reset the password
             */
            token?: string | null;
        },
    }): CancelablePromise<{
        status?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Verify the email of the user
     * @returns any Success
     * @throws ApiError
     */
    public getAuthenticationVerifyEmail({
        token,
        callbackUrl,
    }: {
        /**
         * The token to verify the email
         */
        token: string,
        /**
         * The URL to redirect to after email verification
         */
        callbackUrl?: string,
    }): CancelablePromise<{
        user: User;
        /**
         * Indicates if the email was verified successfully
         */
        status: boolean;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/verify-email',
            query: {
                'token': token,
                'callbackURL': callbackUrl,
            },
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Send a verification email to the user
     * @returns any Success
     * @throws ApiError
     */
    public sendVerificationEmail({
        requestBody,
    }: {
        requestBody?: {
            /**
             * The email to send the verification email to
             */
            email: string;
            /**
             * The URL to use for email verification callback
             */
            callbackURL?: string | null;
        },
    }): CancelablePromise<{
        /**
         * Indicates if the email was sent successfully
         */
        status?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/send-verification-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * @returns any Email change request processed successfully
     * @throws ApiError
     */
    public changeEmail({
        requestBody,
    }: {
        requestBody: {
            /**
             * The new email address to set must be a valid email address
             */
            newEmail: string;
            /**
             * The URL to redirect to after email verification
             */
            callbackURL?: string | null;
        },
    }): CancelablePromise<{
        user?: User;
        /**
         * Indicates if the request was successful
         */
        status: boolean;
        /**
         * Status message of the email change process
         */
        message?: 'Email updated' | 'Verification email sent' | null;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/change-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                422: `Unprocessable Entity. Email already exists`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Change the password of the user
     * @returns any Password successfully changed
     * @throws ApiError
     */
    public changePassword({
        requestBody,
    }: {
        requestBody: {
            /**
             * The new password to set
             */
            newPassword: string;
            /**
             * The current password is required
             */
            currentPassword: string;
            /**
             * Must be a boolean value
             */
            revokeOtherSessions?: boolean | null;
        },
    }): CancelablePromise<{
        /**
         * New session token if other sessions were revoked
         */
        token?: string | null;
        user: {
            /**
             * The unique identifier of the user
             */
            id: string;
            /**
             * The email address of the user
             */
            email: string;
            /**
             * The name of the user
             */
            name: string;
            /**
             * The profile image URL of the user
             */
            image?: string | null;
            /**
             * Whether the email has been verified
             */
            emailVerified: boolean;
            /**
             * When the user was created
             */
            createdAt: string;
            /**
             * When the user was last updated
             */
            updatedAt: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/change-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Update the current user
     * @returns any Success
     * @throws ApiError
     */
    public updateUser({
        requestBody,
    }: {
        requestBody?: {
            /**
             * The name of the user
             */
            name?: string;
            /**
             * The image of the user
             */
            image?: string;
        },
    }): CancelablePromise<{
        user?: User;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/update-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Delete the user
     * @returns any User deletion processed successfully
     * @throws ApiError
     */
    public deleteUser({
        requestBody,
    }: {
        requestBody?: {
            /**
             * The callback URL to redirect to after the user is deleted
             */
            callbackURL?: string;
            /**
             * The user's password. Required if session is not fresh
             */
            password?: string;
            /**
             * The deletion verification token
             */
            token?: string;
        },
    }): CancelablePromise<{
        /**
         * Indicates if the operation was successful
         */
        success: boolean;
        /**
         * Status message of the deletion process
         */
        message: 'User deleted' | 'Verification email sent';
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/delete-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Send a password reset email to the user
     * @returns any Success
     * @throws ApiError
     */
    public forgetPassword({
        requestBody,
    }: {
        requestBody: {
            /**
             * The email address of the user to send a password reset email to
             */
            email: string;
            /**
             * The URL to redirect the user to reset their password. If the token isn't valid or expired, it'll be redirected with a query parameter `?error=INVALID_TOKEN`. If the token is valid, it'll be redirected with a query parameter `?token=VALID_TOKEN
             */
            redirectTo?: string | null;
        },
    }): CancelablePromise<{
        status?: boolean;
        message?: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/request-password-reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Redirects the user to the callback URL with the token
     * @returns any Success
     * @throws ApiError
     */
    public resetPasswordCallback({
        token,
        callbackUrl,
    }: {
        /**
         * The token to reset the password
         */
        token: string,
        /**
         * The URL to redirect the user to reset their password
         */
        callbackUrl: string,
    }): CancelablePromise<{
        token?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/reset-password/{token}',
            path: {
                'token': token,
            },
            query: {
                'callbackURL': callbackUrl,
            },
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * List all active sessions for the user
     * @returns Session Success
     * @throws ApiError
     */
    public listUserSessions(): CancelablePromise<Array<Session>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/list-sessions',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Revoke a single session
     * @returns any Success
     * @throws ApiError
     */
    public postAuthenticationRevokeSession({
        requestBody,
    }: {
        requestBody?: {
            /**
             * The token to revoke
             */
            token: string;
        },
    }): CancelablePromise<{
        /**
         * Indicates if the session was revoked successfully
         */
        status: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/revoke-session',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Revoke all sessions for the user
     * @returns any Success
     * @throws ApiError
     */
    public postAuthenticationRevokeSessions({
        requestBody,
    }: {
        requestBody?: any,
    }): CancelablePromise<{
        /**
         * Indicates if all sessions were revoked successfully
         */
        status: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/revoke-sessions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Revoke all other sessions for the user except the current one
     * @returns any Success
     * @throws ApiError
     */
    public postAuthenticationRevokeOtherSessions({
        requestBody,
    }: {
        requestBody?: any,
    }): CancelablePromise<{
        /**
         * Indicates if all other sessions were revoked successfully
         */
        status: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/revoke-other-sessions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Link a social account to the user
     * @returns any Success
     * @throws ApiError
     */
    public linkSocialAccount({
        requestBody,
    }: {
        requestBody: {
            /**
             * The URL to redirect to after the user has signed in
             */
            callbackURL?: string | null;
            provider: string;
            idToken?: {
                token: string;
                nonce?: string | null;
                accessToken?: string | null;
                refreshToken?: string | null;
                scopes?: any[] | null;
            } | null;
            requestSignUp?: boolean | null;
            /**
             * Additional scopes to request from the provider
             */
            scopes?: any[] | null;
            /**
             * The URL to redirect to if there is an error during the link process
             */
            errorCallbackURL?: string | null;
            /**
             * Disable automatic redirection to the provider. Useful for handling the redirection yourself
             */
            disableRedirect?: boolean | null;
            additionalData?: string | null;
        },
    }): CancelablePromise<{
        /**
         * The authorization URL to redirect the user to
         */
        url?: string;
        /**
         * Indicates if the user should be redirected to the authorization URL
         */
        redirect: boolean;
        status?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/link-social',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * List all accounts linked to the user
     * @returns any Success
     * @throws ApiError
     */
    public listUserAccounts(): CancelablePromise<Array<{
        id: string;
        providerId: string;
        createdAt: string;
        updatedAt: string;
        accountId: string;
        userId: string;
        scopes: Array<string>;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/list-accounts',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Callback to complete user deletion with verification token
     * @returns any User successfully deleted
     * @throws ApiError
     */
    public getAuthenticationDeleteUserCallback({
        token,
        callbackUrl,
    }: {
        token?: string,
        callbackUrl?: string | null,
    }): CancelablePromise<{
        /**
         * Indicates if the deletion was successful
         */
        success: boolean;
        /**
         * Confirmation message
         */
        message: 'User deleted';
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/delete-user/callback',
            query: {
                'token': token,
                'callbackURL': callbackUrl,
            },
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Unlink an account
     * @returns any Success
     * @throws ApiError
     */
    public postAuthenticationUnlinkAccount({
        requestBody,
    }: {
        requestBody: {
            providerId: string;
            accountId?: string | null;
        },
    }): CancelablePromise<{
        status?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/unlink-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Refresh the access token using a refresh token
     * @returns any Access token refreshed successfully
     * @throws ApiError
     */
    public postAuthenticationRefreshToken({
        requestBody,
    }: {
        requestBody: {
            /**
             * The provider ID for the OAuth provider
             */
            providerId: string;
            /**
             * The account ID associated with the refresh token
             */
            accountId?: string | null;
            /**
             * The user ID associated with the account
             */
            userId?: string | null;
        },
    }): CancelablePromise<{
        tokenType?: string;
        idToken?: string;
        accessToken?: string;
        refreshToken?: string;
        accessTokenExpiresAt?: string;
        refreshTokenExpiresAt?: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/refresh-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid refresh token or provider configuration`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Get a valid access token, doing a refresh if needed
     * @returns any A Valid access token
     * @throws ApiError
     */
    public postAuthenticationGetAccessToken({
        requestBody,
    }: {
        requestBody: {
            /**
             * The provider ID for the OAuth provider
             */
            providerId: string;
            /**
             * The account ID associated with the refresh token
             */
            accountId?: string | null;
            /**
             * The user ID associated with the account
             */
            userId?: string | null;
        },
    }): CancelablePromise<{
        tokenType?: string;
        idToken?: string;
        accessToken?: string;
        refreshToken?: string;
        accessTokenExpiresAt?: string;
        refreshTokenExpiresAt?: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/authentication/get-access-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid refresh token or provider configuration`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Get the account info provided by the provider
     * @returns any Success
     * @throws ApiError
     */
    public getAuthenticationAccountInfo(): CancelablePromise<{
        user: {
            id: string;
            name?: string;
            email?: string;
            image?: string;
            emailVerified: boolean;
        };
        data: Record<string, any>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/account-info',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Check if the API is working
     * @returns any API is working
     * @throws ApiError
     */
    public getAuthenticationOk(): CancelablePromise<{
        /**
         * Indicates if the API is working
         */
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/ok',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

    /**
     * Displays an error page
     * @returns string Success
     * @throws ApiError
     */
    public getAuthenticationError(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/authentication/error',
            errors: {
                400: `Bad Request. Usually due to missing parameters, or invalid parameters.`,
                401: `Unauthorized. Due to missing or invalid authentication.`,
                403: `Forbidden. You do not have permission to access this resource or to perform this action.`,
                404: `Not Found. The requested resource was not found.`,
                429: `Too Many Requests. You have exceeded the rate limit. Try again later.`,
                500: `Internal Server Error. This is a problem with the server that you cannot fix.`,
            },
        });
    }

}
